import moment from 'moment';

const classesOf = (value) => String(value || '').toLowerCase().split('/').map((part) => part.trim())
  .filter(Boolean);
const classKey = (value) => classesOf(value).sort().join('/');

export default function substituteConflicts(row, records, plan, fallbackDate, epochs = []) {
  if (!row.substitute || !row.substitute.id) return [];
  const teacher = records.find((record) => String(record.id) === String(row.substitute.id));
  const weekday = (moment(plan.daydate || fallbackDate).day() + 6) % 7;
  const day = teacher && teacher.week && teacher.week[weekday];
  if (!day) return [];
  const hours = (row.hours && row.hours.length ? row.hours : [row.hour]).map(String);
  const absentClasses = (plan.absent_classes || [])
    .reduce((all, value) => all.concat(classesOf(value)), []);
  const epoch = ((epochs[0] && epochs[0].classes) || [])
    .filter((entry) => entry.teacher && String(entry.teacher.id) === String(teacher.id)).pop();
  return day.hours.map((lesson, index) => (epoch && index < 2
    ? { ...lesson, class: epoch.class, subject: epoch.subject } : lesson))
    .filter((lesson) => {
      const classes = classesOf(lesson.class);
      return hours.includes(String(lesson.name)) && String(lesson.subject || '').trim()
        && !(classes.length && classes.every((klass) => absentClasses.includes(klass)))
        && !(classKey(lesson.class) && classKey(lesson.class) === classKey(row.class));
    });
}
